/**
 * Polska nazwa kraju na podstawie kodu ISO 3166-1 alpha-2.
 *
 * Medusa przechowuje nazwy krajów po angielsku ("Poland"), a sklep jest polski.
 * Tłumaczymy je przez Intl zamiast trzymać własną tabelę; gdy Intl nie zna kodu
 * albo nie jest dostępny, zwracamy oryginał, żeby nigdy nie pokazać pustego pola.
 */
export const localizeCountry = (
  iso2?: string | null,
  fallback?: string | null
): string => {
  if (!iso2) {
    return fallback ?? ""
  }

  try {
    const names = new Intl.DisplayNames(["pl"], { type: "region" })
    return names.of(iso2.toUpperCase()) ?? fallback ?? iso2
  } catch {
    return fallback ?? iso2
  }
}
